export const carouselLeft =
	() => `<svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.533761 4.5546C0.235709 4.24486 0.235709 3.75495 0.53376 3.4452L3.12354 0.753826C3.62288 0.234891 4.5 0.588359 4.5 1.30853L4.5 6.69128C4.5 7.41145 3.62289 7.76491 3.12354 7.24598L0.533761 4.5546Z" fill="inherit"/>
</svg>
`;
